import axios from 'axios'
import ResourceConstants from 'constants/ResourceConstants'

export const tryResolveLoginPageUrl = ({ email }) => {
  return axios.post(`${ResourceConstants.AUTH_API}/sso/saml/enabled`, { email })
    .then(response => response.data)
}

export const resolveSsoRedirectUrl = ({ email, nextUrl, authClientId }) => {
  const payload = { email, postLoginUrl: nextUrl, authClientId }
  return axios.post(`${ResourceConstants.AUTH_API}/sso/saml/login-url`, payload)
    .then(response => response.data.url)
}



// WEBPACK FOOTER //
// ./src/api/sso.js